import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  imageUrl: string;
}

export default function ArticleCard({ slug, title, excerpt, category, imageUrl }: ArticleCardProps) {
  return (
    <Link
      to={`/${slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200/50 transition-all duration-300 hover:-translate-y-1 cursor-pointer"
    >
      <div className="relative h-48 overflow-hidden">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-3 py-1 text-xs font-medium bg-accent-100/90 text-accent-800 rounded-full">
            {category}
          </span>
        </div>
      </div>
      <div className="p-5">
        <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
          {title}
        </h3>
        <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
          {excerpt}
        </p>
        <div className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600">
          Read More
          <i className="ri-arrow-right-line text-xs"></i>
        </div>
      </div>
    </Link>
  );
}